import $ from 'jquery';

$.fn.ariaExpanded = function(toggleOn) {
  return this.attr('aria-expanded', toggleOn);
};

$.fn.ariaHidden = function(toggleOn) {
  return this.attr('aria-hidden', toggleOn);
};
